import { render } from "./FinalView.vue?vue&type=template&id=453d9794"
import script from "./FinalView.vue?vue&type=script&lang=js"
export * from "./FinalView.vue?vue&type=script&lang=js"

import "./FinalView.vue?vue&type=style&index=0&id=453d9794&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__